import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Safe Search Terms`}</h2>
    <p>{`GIPHY maintains a list of keywords that will not return any results. These keywords are associated with content that is forbidden per our Community Guidelines. The list is regularly reviewed and updated to ensure that it includes topical, timely, and relevant entries.`}</p>
    <p>{`API & SDK Partners can report inappropriate search queries by contacting `}<a href="mailto:support@giphy.com"><a parentName="p" {...{
          "href": "mailto:support@giphy.com"
        }}>{`support@giphy.com`}</a></a>{`. Keywords can be added to the banned search query list when appropriate.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      